(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1916],{

/***/ 21916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "PF": function() { return /* reexport */ CarReviewsHubFeature; }
});

// UNUSED EXPORTS: V2GetStaticProps, getStaticPathForMakes, getStaticPathForModels, getStaticPathsForPage

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../libs/data/storyblok/src/index.ts + 18 modules
var src = __webpack_require__(60782);
// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/index.ts + 264 modules
var shared_src = __webpack_require__(60620);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/index.ts + 57 modules
var ui_src = __webpack_require__(72284);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../node_modules/next/router.js
var router = __webpack_require__(35837);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-hub/src/lib/components/pagination/pagination.tsx



const ReviewHubPagination = ({ currentPage , resultsPerPage =10 , total , isISR =false  })=>{
    const { isFallback , query , asPath  } = (0,router.useRouter)();
    const dict = {};
    if (isISR) {
        /*
     ** Please note this is very hacky and should be refactored
     ** In this case 'make' is actually the first part of the path immendiately after '/reviews/'
     ** And 'model' is actually the second part of the path immendiately after '/make/'
     ** The values of make could be actual car makes or 'page'
     ** likewise the values of model could be actual car models or 'page'
     */ const [make, model] = asPath.split("/").slice(2);
        if (make && make !== "page") {
            dict.make = make;
        }
        if (model) {
            dict.model = model;
        }
    } else {
        if (typeof query.make === "string") {
            dict.make = query.make;
            if (typeof query.model === "string") {
                dict.model = query.model;
            }
        }
    }
    const queryString = new URLSearchParams(dict).toString();
    if (isFallback) {
        return null;
    }
    const sourcePage = isISR && dict.make ? `reviews/${dict.make}` : "reviews";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Pagination */.tl, {
        totalItemsCount: total,
        activePage: currentPage,
        itemsCountPerPage: resultsPerPage,
        sourcePage: sourcePage,
        enabledLinks: true,
        includedQueryParams: queryString.length > 0 && isISR === false ? `?${queryString.toString()}` : ""
    });
};

// EXTERNAL MODULE: ../../../libs/shared/analytics/src/index.ts + 26 modules
var analytics_src = __webpack_require__(40731);
;// CONCATENATED MODULE: ../../../libs/data/tracking/src/lib/use-car-reviews-hub.tracking.ts

const trackOnFilterChange = (trackEvent)=>(name, filterSection)=>{
        if (name === "") {
            name = `All ${filterSection}s`;
        }
        const data = {
            event: {
                name: analytics_src/* EventNames.click */.Vy.click,
                category: analytics_src/* EventCategories.button */.ro.button,
                action: analytics_src/* EventActions.filter */.DI.filter,
                label: name,
                section: filterSection
            }
        };
        trackEvent({
            eventName: `Car reviews hub - filter ${filterSection}`,
            data,
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE
        });
    };
const trackOnReviewCardClick = (trackEvent)=>(reviewTitle)=>{
        const data = {
            event: {
                name: analytics_src/* EventNames.click */.Vy.click,
                category: analytics_src/* EventCategories.button */.ro.button,
                action: analytics_src/* EventActions.navigate */.DI.navigate,
                label: reviewTitle
            }
        };
        trackEvent({
            eventName: "Car reviews hub - click review card",
            data,
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE
        });
    };
const trackNoResultsFound = (trackEvent)=>(name)=>{
        const data = {
            event: {
                name: analytics_src/* EventNames.impression */.Vy.impression,
                category: analytics_src/* EventCategories.reviews */.ro.reviews,
                action: analytics_src/* EventActions.noReviewsFound */.DI.noReviewsFound,
                label: name
            }
        };
        trackEvent({
            eventName: "Car reviews hub - No car reviews found",
            data,
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE
        });
    };
const useCarReviewsHubTracking = ()=>(0,analytics_src/* useAnalytics */.z$)(({ trackEvent  })=>({
            trackOnFilterChange: trackOnFilterChange(trackEvent),
            trackOnReviewCardClick: trackOnReviewCardClick(trackEvent),
            trackNoResultsFound: trackNoResultsFound(trackEvent)
        }));

;// CONCATENATED MODULE: ../../../libs/data/tracking/src/index.ts


// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/design-system/dist/index.esm.js
var index_esm = __webpack_require__(55370);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-hub/src/lib/components/no-reviews/no-reviews-image.svg
var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const SvgNoReviewsImage = props => /*#__PURE__*/react.createElement("svg", _extends({
  width: 250,
  height: 250,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
  filter: "url(#a)"
}, /*#__PURE__*/react.createElement("path", {
  d: "M91.001 44A81 81 0 1 0 91 206a81 81 0 0 0 .002-162Zm0 145.774a64.777 64.777 0 0 1-59.842-39.987 64.773 64.773 0 1 1 119.687.002 64.763 64.763 0 0 1-35.056 35.058 64.764 64.764 0 0 1-24.789 4.931v-.004Z",
  fill: "url(#b)"
}), /*#__PURE__*/react.createElement("path", {
  opacity: 0.15,
  d: "M25 139.985 135.25 205 205 162.78 93.625 99 25 139.985Z",
  fill: "#000"
}), /*#__PURE__*/react.createElement("path", {
  d: "M132.952 204 245 169.163 187.599 99 87 127.405 132.952 204Z",
  fill: "url(#c)"
}), /*#__PURE__*/react.createElement("path", {
  d: "M135.608 204 135 190.017l48.351-31.78L205 151l-.158 11.405L135.608 204Z",
  fill: "url(#d)"
}), /*#__PURE__*/react.createElement("path", {
  d: "M135.608 204 135 190.017l48.351-31.78L205 151l-.158 11.405L135.608 204Z",
  fill: "url(#e)"
}), /*#__PURE__*/react.createElement("path", {
  opacity: 0.4,
  d: "M135.608 204 135 190.017l48.351-31.78L205 151l-.158 11.405L135.608 204Z",
  fill: "#000"
}), /*#__PURE__*/react.createElement("path", {
  d: "M26 139.428 26.16 125l106.979 61.487 2.724 4.81L136 204 26 139.428Z",
  fill: "url(#f)"
}), /*#__PURE__*/react.createElement("path", {
  d: "M26 127.097V117l107.378 55.932 2.594 8.055L136 191 26 127.097Z",
  fill: "url(#g)"
}), /*#__PURE__*/react.createElement("path", {
  d: "m136.028 191-.028-9.978 47.667-36.292L205 141v9.61L136.028 191Z",
  fill: "url(#h)"
}), /*#__PURE__*/react.createElement("path", {
  opacity: 0.3,
  d: "m136.028 191-.028-9.978 47.667-36.292L205 141v9.61L136.028 191Z",
  fill: "#000"
}), /*#__PURE__*/react.createElement("path", {
  d: "M26 117.519 135.352 181 205 141.155 95.65 77 26 117.519Z",
  fill: "url(#i)"
}), /*#__PURE__*/react.createElement("path", {
  d: "M26 117.519 135.352 181 205 141.155 95.65 77 26 117.519Z",
  fill: "url(#j)"
}), /*#__PURE__*/react.createElement("path", {
  d: "m191.098 135.873-4.576 2.774.141-.247-90.012-51.901 7.413-4.385L102.167 81 33 121.908l1.908 1.107 8.14-4.814 89.656 51.695-4.943 2.996 1.908 1.108 11.49-6.964-1.897-1.114-4.678 2.834-89.631-51.681 49.8-29.454 90.171 51.993-5.322 3.226 1.908 1.108 11.49-6.964-1.902-1.111Z",
  fill: "#F9F9F9"
}), /*#__PURE__*/react.createElement("path", {
  opacity: 0.79,
  d: "m205 141.436-27.851-16.43c.241-.333-29.319 12.903-29.319 12.903l-.83 9.643 3.338 4.448 40.135-2.242L205 141.436Z",
  fill: "url(#k)"
}), /*#__PURE__*/react.createElement("path", {
  opacity: 0.14,
  d: "M148.047 155 162 146.522 148.088 138 134 146.568 148.047 155Z",
  fill: "#000"
}), /*#__PURE__*/react.createElement("path", {
  d: "M148.792 154 134 145.63V144l10.77 3.886 4.022 4.324.208 1.332-.208.458Z",
  fill: "#93287D"
}), /*#__PURE__*/react.createElement("path", {
  d: "M148 152.218V154l13.89-8.304L162 144l-8.668 3.435-5.332 4.783Z",
  fill: "#752265"
}), /*#__PURE__*/react.createElement("path", {
  d: "M148.047 152 162 144.021 148.088 136 134 144.064 148.047 152Z",
  fill: "url(#l)"
}), /*#__PURE__*/react.createElement("path", {
  d: "M149.125 125.587c-.034-.327-.544-.587-1.17-.587-.626 0-1.142.263-1.171.593 0 0-5.784 18.33-5.784 18.697 0 2.049 3.134 3.71 7 3.71s7-1.657 7-3.71c-.002-.47-5.875-18.703-5.875-18.703Z",
  fill: "url(#m)"
}), /*#__PURE__*/react.createElement("path", {
  d: "M148.5 126c.828 0 1.5-.224 1.5-.5s-.672-.5-1.5-.5-1.5.224-1.5.5.672.5 1.5.5Z",
  fill: "#CC429A"
}), /*#__PURE__*/react.createElement("path", {
  d: "M153.5 137c.005.099.003.199-.007.298 0 1.507-2.074 2.728-5.048 2.728s-5.123-.974-5.123-2.481c.002-.123.02-.246.054-.365l-1.279 3.978a1.719 1.719 0 0 0-.097.564c0 1.81 2.893 3.278 6.463 3.278 3.57 0 6.537-1.597 6.537-3.408-.132-.372-1.5-4.592-1.5-4.592Zm-2.722-7.955c.004.067.004.135 0 .202 0 1.025-.759 1.605-2.359 1.605s-2.268-.58-2.268-1.605c.001-.083.011-.166.029-.247l-1.128 4.389a1.444 1.444 0 0 0-.052.383c0 1.231 1.558 2.228 3.478 2.228 1.92 0 3.522-1.086 3.522-2.316-.072-.253-1.222-4.639-1.222-4.639Z",
  fill: "#F9F9F9"
}), /*#__PURE__*/react.createElement("path", {
  opacity: 0.1,
  d: "M149.125 125.587c-.034-.327-.544-.587-1.17-.587-.626 0-1.142.263-1.171.593 0 0-5.784 18.33-5.784 18.697 0 2.049 3.134 3.71 7 3.71s7-1.657 7-3.71c-.002-.47-5.875-18.703-5.875-18.703Z",
  fill: "#000"
}), /*#__PURE__*/react.createElement("path", {
  opacity: 0.9,
  d: "M148.32 125c-.107 0-.214.008-.32.022.495 3.552 1.014 19.194 1.138 22.978 3.853-.188 6.862-1.769 6.862-3.695 0-.469-6.402-18.718-6.402-18.718-.041-.327-.595-.587-1.278-.587Z",
  fill: "url(#n)"
}))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
  id: "b",
  x1: 14.698,
  y1: 142.172,
  x2: 168.274,
  y2: 107.504,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/react.createElement("stop", {
  stopColor: "#7DFFB4"
}), /*#__PURE__*/react.createElement("stop", {
  offset: 1,
  stopColor: "#44E4FF"
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "c",
  x1: 123.024,
  y1: 178.905,
  x2: 179.946,
  y2: 87.011,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/react.createElement("stop", {
  stopOpacity: 0.122
}), /*#__PURE__*/react.createElement("stop", {
  offset: 0.663,
  stopOpacity: 0
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "d",
  x1: 200.17,
  y1: 157.413,
  x2: 141.623,
  y2: 216.928,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/react.createElement("stop", {
  stopColor: "#FE33CB"
}), /*#__PURE__*/react.createElement("stop", {
  offset: 1,
  stopColor: "#F65B6F"
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "e",
  x1: 138.57,
  y1: 193.082,
  x2: 183.167,
  y2: 148.669,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/react.createElement("stop", {
  offset: 0.097,
  stopColor: "#F65B6F"
}), /*#__PURE__*/react.createElement("stop", {
  offset: 0.851,
  stopColor: "#FE33CB"
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "f",
  x1: 131.49,
  y1: 193.256,
  x2: 67.906,
  y2: 122.922,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/react.createElement("stop", {
  stopColor: "#F65B6F"
}), /*#__PURE__*/react.createElement("stop", {
  offset: 1,
  stopColor: "#FE33CB"
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "g",
  x1: 140.51,
  y1: 185.154,
  x2: 62.874,
  y2: 92.364,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/react.createElement("stop", {
  offset: 0.099,
  stopColor: "#715CCF"
}), /*#__PURE__*/react.createElement("stop", {
  offset: 0.959,
  stopColor: "#50C5F6"
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "h",
  x1: 121.234,
  y1: 192.9,
  x2: 202.698,
  y2: 96.885,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/react.createElement("stop", {
  offset: 0.197,
  stopColor: "#715CCF"
}), /*#__PURE__*/react.createElement("stop", {
  offset: 0.92,
  stopColor: "#50C5F6"
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "i",
  x1: 28.327,
  y1: 112.256,
  x2: 175.773,
  y2: 196.16,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/react.createElement("stop", {
  offset: 0.075,
  stopColor: "#50C5F6"
}), /*#__PURE__*/react.createElement("stop", {
  offset: 0.813,
  stopColor: "#715CCF"
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "j",
  x1: -22.509,
  y1: 102.48,
  x2: 129.681,
  y2: 189.192,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/react.createElement("stop", {
  offset: 0.365,
  stopOpacity: 0.302
}), /*#__PURE__*/react.createElement("stop", {
  offset: 0.819,
  stopOpacity: 0
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "k",
  x1: 147,
  y1: 138.5,
  x2: 205,
  y2: 138.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/react.createElement("stop", {
  offset: 0.182,
  stopOpacity: 0.251
}), /*#__PURE__*/react.createElement("stop", {
  offset: 0.682,
  stopOpacity: 0
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "l",
  x1: 134,
  y1: 144,
  x2: 162,
  y2: 144,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/react.createElement("stop", {
  stopColor: "#FE33CB"
}), /*#__PURE__*/react.createElement("stop", {
  offset: 1,
  stopColor: "#F65B6F"
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "m",
  x1: 156.96,
  y1: 147.149,
  x2: 140.044,
  y2: 140.93,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/react.createElement("stop", {
  stopColor: "#FE33CB"
}), /*#__PURE__*/react.createElement("stop", {
  offset: 0.734,
  stopColor: "#F65B6F"
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "n",
  x1: 158.48,
  y1: 135.304,
  x2: 144.986,
  y2: 135.507,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/react.createElement("stop", {
  offset: 0.079
}), /*#__PURE__*/react.createElement("stop", {
  offset: 0.814,
  stopOpacity: 0
})), /*#__PURE__*/react.createElement("filter", {
  id: "a",
  x: -4,
  y: 0,
  width: 258,
  height: 258,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/react.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/react.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/react.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/react.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/react.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/react.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/react.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_410_3456"
}), /*#__PURE__*/react.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_410_3456",
  result: "shape"
})))));
/* harmony default export */ var no_reviews_image = (SvgNoReviewsImage);
// EXTERNAL MODULE: ../../../libs/landing/feature-car-reviews-hub/src/lib/components/no-reviews/no-reviews.module.css
var no_reviews_module = __webpack_require__(40983);
var no_reviews_module_default = /*#__PURE__*/__webpack_require__.n(no_reviews_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-hub/src/lib/components/no-reviews/no-reviews.tsx






const NoReviews = ({ selectedMake , selectedModel  })=>{
    const { trackNoResultsFound  } = useCarReviewsHubTracking();
    (0,react.useEffect)(()=>{
        if (!!selectedMake || !!selectedModel) {
            trackNoResultsFound(`${selectedMake} ${selectedModel ? selectedModel : ""}`.trim());
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedMake,
        selectedModel
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (no_reviews_module_default()).container,
        "data-testid": "no-reviews",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(no_reviews_image, {
                className: (no_reviews_module_default()).icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                element: "h2",
                fontWeight: "bold",
                className: (no_reviews_module_default()).header,
                children: "No results found"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                className: (no_reviews_module_default()).body,
                children: "Sorry, we don’t have any reviews matching that. Please try some different filters."
            })
        ]
    });
};

// EXTERNAL MODULE: ../../../node_modules/classnames/index.js
var classnames = __webpack_require__(95685);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../../node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(19601);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ../../../libs/landing/feature-car-reviews-hub/src/lib/components/review-card/review-card.module.css
var review_card_module = __webpack_require__(269);
var review_card_module_default = /*#__PURE__*/__webpack_require__.n(review_card_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-hub/src/lib/components/assets/star-fill.tsx

const StarFill = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "filled-star",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12 20.0477L6.37839 23.022C5.64511 23.41 4.78553 22.7879 4.92494 21.9701L6.00062 15.6604L1.43919 11.1863C0.848808 10.6072 1.17645 9.60257 1.99471 9.4829L8.29186 8.56193L11.1021 2.83096C11.4681 2.08467 12.5319 2.08467 12.8978 2.83096L15.7081 8.56193L22.0053 9.4829C22.8235 9.60257 23.1512 10.6072 22.5608 11.1863L17.9994 15.6604L19.075 21.9701C19.2144 22.7879 18.3549 23.41 17.6216 23.022L12 20.0477Z",
            fill: "#5234B6"
        })
    });

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-hub/src/lib/components/assets/star-half-fill.tsx

const StarHalfFill = ({ idPrefix  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "half-filled-star",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 18.3507L17.4258 21.2214L16.3888 15.139L20.7908 10.8212L14.7092 9.93179L12 4.40688L9.29076 9.93179L3.20914 10.8212L7.61115 15.139L6.57422 21.2214L12 18.3507ZM6.00062 15.6604L4.92494 21.9701C4.78553 22.7879 5.64511 23.41 6.37839 23.022L12 20.0477L17.6216 23.022C18.3549 23.41 19.2144 22.7879 19.075 21.9701L17.9994 15.6604L22.5608 11.1863C23.1512 10.6072 22.8235 9.60257 22.0053 9.4829L15.7081 8.56193L12.8978 2.83096C12.5319 2.08467 11.4681 2.08467 11.1021 2.83096L8.29186 8.56193L1.99471 9.4829C1.17645 9.60257 0.848808 10.6072 1.43919 11.1863L6.00062 15.6604Z",
                fill: "#5234B6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: `${idPrefix}-half-fill-mask`,
                x: "0",
                y: "0",
                width: "12",
                height: "24",
                fill: "white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "0",
                    y: "0",
                    width: "12",
                    height: "24"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 18.3507L17.4258 21.2214L16.3888 15.139L20.7908 10.8212L14.7092 9.93179L12 4.40688L9.29076 9.93179L3.20914 10.8212L7.61115 15.139L6.57422 21.2214L12 18.3507ZM6.00062 15.6604L4.92494 21.9701C4.78553 22.7879 5.64511 23.41 6.37839 23.022L12 20.0477L17.6216 23.022C18.3549 23.41 19.2144 22.7879 19.075 21.9701L17.9994 15.6604L22.5608 11.1863C23.1512 10.6072 22.8235 9.60257 22.0053 9.4829L15.7081 8.56193L12.8978 2.83096C12.5319 2.08467 11.4681 2.08467 11.1021 2.83096L8.29186 8.56193L1.99471 9.4829C1.17645 9.60257 0.848808 10.6072 1.43919 11.1863L6.00062 15.6604Z",
                fill: "#5234B6",
                mask: `url(#${idPrefix}-half-fill-mask)`
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-hub/src/lib/components/assets/star-no-fill.tsx

const StarNoFill = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "empty-star",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 18.3507L17.4258 21.2214L16.3888 15.139L20.7908 10.8212L14.7092 9.93179L12 4.40688L9.29076 9.93179L3.20914 10.8212L7.61115 15.139L6.57422 21.2214L12 18.3507ZM6.00062 15.6604L4.92494 21.9701C4.78553 22.7879 5.64511 23.41 6.37839 23.022L12 20.0477L17.6216 23.022C18.3549 23.41 19.2144 22.7879 19.075 21.9701L17.9994 15.6604L22.5608 11.1863C23.1512 10.6072 22.8235 9.60257 22.0053 9.4829L15.7081 8.56193L12.8978 2.83096C12.5319 2.08467 11.4681 2.08467 11.1021 2.83096L8.29186 8.56193L1.99471 9.4829C1.17645 9.60257 0.848808 10.6072 1.43919 11.1863L6.00062 15.6604Z",
            fill: "#5234B6"
        })
    });

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-hub/src/lib/components/assets/index.ts




// EXTERNAL MODULE: ../../../libs/landing/feature-car-reviews-hub/src/lib/components/star-rating/star-rating.module.css
var star_rating_module = __webpack_require__(41365);
var star_rating_module_default = /*#__PURE__*/__webpack_require__.n(star_rating_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-hub/src/lib/components/star-rating/star-rating.tsx



const StarRating = ({ starRating  })=>{
    const stars = [
        ...Array.from({
            length: 5
        }).keys()
    ];
    const starComponents = stars.map((_, index)=>{
        const starNumber = index + 1;
        const idPrefix = `star-${starRating}-${starNumber}`;
        const isFilled = starNumber <= Math.floor(starRating / 2);
        const isHalf = starNumber === Math.ceil(starRating / 2) && starRating % 2 !== 0;
        return isFilled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StarFill, {}, starNumber) : isHalf ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StarHalfFill, {
            idPrefix: idPrefix
        }, starNumber) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StarNoFill, {}, starNumber);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (star_rating_module_default()).starRatingContainer,
        children: starComponents
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-hub/src/lib/components/star-rating/index.ts


;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-hub/src/lib/components/review-card/review-card.tsx






const ReviewCard = ({ title ="" , image , starRating ="" , snippet ="" , featured =false  })=>{
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("article", {
        className: classnames_default()((review_card_module_default()).root, {
            [(review_card_module_default()).topCard]: featured
        }),
        "data-featured": featured,
        "data-uid": title,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((review_card_module_default()).imageContainer, {
                    [(review_card_module_default()).featured]: featured
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: (review_card_module_default()).image,
                    alt: (image === null || image === void 0 ? void 0 : image.alt) ?? "",
                    src: (image === null || image === void 0 ? void 0 : image.filename) || `${ false ? 0 : "https://landing-articles.snc-prod.aws.cinch.co.uk"}/image-coming-soon.svg`,
                    layout: "fixed",
                    width: featured ? 400 : 250,
                    height: featured ? 253 : 158,
                    priority: featured
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        type: featured ? index_esm/* TextStyles.vehicleTitle */.k7.vehicleTitle : index_esm/* TextStyles.mainTitle */.k7.mainTitle,
                        element: "h2",
                        className: (review_card_module_default()).title,
                        lineHeight: "display",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StarRating, {
                        starRating: +starRating
                    }),
                    snippet && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        element: "p",
                        className: (review_card_module_default()).snippet,
                        children: snippet
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../../libs/landing/feature-car-reviews-hub/src/lib/components/review-cards-list/review-cards-list.module.css
var review_cards_list_module = __webpack_require__(90710);
var review_cards_list_module_default = /*#__PURE__*/__webpack_require__.n(review_cards_list_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-hub/src/lib/components/review-cards-list/review-cards-list.tsx







const ReviewCardsList = ({ reviews , page , isLoading =true , selectedMake , selectedModel  })=>{
    const { isFallback  } = (0,router.useRouter)();
    const { trackOnReviewCardClick  } = useCarReviewsHubTracking();
    const filteredReviews = reviews === null || reviews === void 0 ? void 0 : reviews.filter((item)=>!!(item && item.path));
    if (isFallback || isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            "data-testid": "skeletonPlaceHolder",
            children: Array.from({
                length: 10
            }).map((_, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* HubCardSkeleton */.dL, {
                    featured: idx === 0
                }, idx))
        });
    }
    return (filteredReviews === null || filteredReviews === void 0 ? void 0 : filteredReviews.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        children: filteredReviews === null || filteredReviews === void 0 ? void 0 : filteredReviews.map((item, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: (review_cards_list_module_default()).listItem,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: item.path,
                    className: (review_cards_list_module_default()).link,
                    "aria-label": item.title,
                    onClick: ()=>trackOnReviewCardClick(`${item.make} ${item.model}`),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewCard, {
                        title: item.title,
                        image: item.heroImage,
                        starRating: item.starRating,
                        snippet: item.snippet,
                        featured: idx === 0 && page === 1
                    })
                })
            }, item.id))
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NoReviews, {
        selectedMake: selectedMake,
        selectedModel: selectedModel
    });
};

// EXTERNAL MODULE: ../../../libs/landing/feature-car-reviews-hub/src/lib/components/header/header.module.css
var header_module = __webpack_require__(89671);
var header_module_default = /*#__PURE__*/__webpack_require__.n(header_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-hub/src/lib/components/header/header.tsx



const ReviewsPageHeader = ({ title , subtitle  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (header_module_default()).reviewsHeader,
        "data-testid": "reviews-hub-title",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                fontWeight: "bold",
                fontSize: "4xl",
                element: "h1",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                className: (header_module_default()).subtitle,
                fontWeight: "light",
                fontSize: "xxl",
                children: subtitle
            })
        ]
    });

// EXTERNAL MODULE: ../../../libs/landing/feature-car-reviews-hub/src/lib/components/filters/filters.module.css
var filters_module = __webpack_require__(53584);
var filters_module_default = /*#__PURE__*/__webpack_require__.n(filters_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-hub/src/lib/components/filters/filters.tsx




function onMakeChange({ setIsLoading , trackOnFilterChange , isISR =false  }) {
    return (event)=>{
        setIsLoading(true);
        trackOnFilterChange(event.currentTarget.value, "make");
        const rawParams = {};
        if (event.currentTarget.value) {
            rawParams.make = event.currentTarget.value;
        }
        if (isISR) {
            window.location.href = `/reviews/${rawParams.make}`;
            return;
        }
        const urlParams = new URLSearchParams(rawParams);
        window.location.href = `/reviews?${urlParams.toString()}`;
    };
}
function onModelChange({ selectedMake , setIsLoading , trackOnFilterChange , isISR =false  }) {
    return (event)=>{
        setIsLoading(true);
        trackOnFilterChange(event.currentTarget.value, "model");
        const rawParams = {
            make: selectedMake
        };
        if (event.currentTarget.value) {
            rawParams.model = event.currentTarget.value;
        }
        if (isISR) {
            window.location.href = `/reviews/${rawParams.make}/${rawParams.model}`;
            return;
        }
        const urlParams = new URLSearchParams(rawParams);
        window.location.href = `/reviews${urlParams.toString() ? `?${urlParams.toString()}` : ""}`;
    };
}
const Filters = ({ selectedMake ="" , selectedModel ="" , makes =[] , models =[] , isLoading , setIsLoading , isISR =false  })=>{
    const { trackOnFilterChange  } = useCarReviewsHubTracking();
    const selectFieldClassNames = {
        container: (filters_module_default()).selectContainer,
        select: (filters_module_default()).select
    };
    selectedMake = selectedMake ?? "";
    selectedModel = selectedModel ?? "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (filters_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SelectField */.mg, {
                id: "make-options",
                placeholder: "All makes",
                value: selectedMake,
                disabled: isLoading,
                options: [
                    {
                        label: "All makes",
                        value: ""
                    },
                    ...makes.map((make)=>({
                            label: make,
                            value: make
                        }))
                ],
                label: "Filter by make",
                classNames: selectFieldClassNames,
                onChange: onMakeChange({
                    setIsLoading,
                    trackOnFilterChange,
                    isISR
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SelectField */.mg, {
                id: "model-options",
                placeholder: "All models",
                value: selectedModel,
                options: [
                    {
                        label: "All models",
                        value: ""
                    },
                    ...models.map((model)=>({
                            label: model,
                            value: model
                        }))
                ],
                label: "Filter by model",
                classNames: selectFieldClassNames,
                disabled: isLoading || selectedMake === "",
                onChange: onModelChange({
                    selectedMake,
                    setIsLoading,
                    trackOnFilterChange,
                    isISR
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-hub/src/lib/components/index.ts






// EXTERNAL MODULE: ../../../libs/landing/feature-car-reviews-hub/src/lib/car-reviews-hub.module.css
var car_reviews_hub_module = __webpack_require__(23754);
var car_reviews_hub_module_default = /*#__PURE__*/__webpack_require__.n(car_reviews_hub_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-hub/src/lib/car-reviews-hub.tsx







function CarReviewsHubFeature({ preview =false , isISR =false , story , makeOptions , modelOptions , generatedAt , currentPage , numberOfReviews , resultsPerPage , reviews , selectedMake , selectedModel  }) {
    const { content  } = (0,src/* useStoryblokState */.f0)({
        story,
        enableBridge: preview
    });
    const { title , subtitle  } = content ?? {
        title: "Loading",
        subtitle: "Loading..."
    };
    const [SEO] = (content === null || content === void 0 ? void 0 : content.SEO) ?? [
        {}
    ];
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setIsLoading(false);
    }, [
        reviews
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* Head */.Fb, {
                ...SEO,
                generatedAt: generatedAt,
                fallbackTitle: "Cars Without The Faff - cinch",
                fallbackDescription: "Welcome to cinch, the faff free way to buy & sell cars. We have thousands of used cars, ready to be sold to you."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                className: (car_reviews_hub_module_default()).page,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_src/* Wrapper */.im, {
                    isSlim: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsPageHeader, {
                            title: title,
                            subtitle: subtitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters, {
                            selectedMake: selectedMake,
                            selectedModel: selectedModel,
                            makes: makeOptions,
                            models: modelOptions,
                            isLoading: isLoading,
                            setIsLoading: setIsLoading,
                            isISR: isISR
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewCardsList, {
                            reviews: reviews,
                            page: currentPage,
                            isLoading: isLoading,
                            selectedMake: selectedMake,
                            selectedModel: selectedModel
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewHubPagination, {
                            currentPage: currentPage,
                            total: numberOfReviews,
                            resultsPerPage: resultsPerPage,
                            isISR: isISR
                        })
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ../../../libs/shared/util/src/index.ts + 25 modules
var util_src = __webpack_require__(37479);
// EXTERNAL MODULE: ../../../libs/core/datadog-server/src/index.ts + 7 modules
var datadog_server_src = __webpack_require__(86634);
;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-hub/src/lib/get-static-props.ts



const getAllStories = (0,datadog_server_src/* traceFunction */.KG)("getAllStories", src/* getAllStories */.IO);
const getStories = (0,datadog_server_src/* traceFunction */.KG)("getStories", src/* getStories */.EW);
const getStoryBySlug = (0,datadog_server_src/* traceFunction */.KG)("getStoryBySlug", src/* getStoryBySlug */.OI);
async function getStaticProps({ params , preview =false  }) {
    try {
        let page = 1;
        let make;
        let model;
        const version = preview ? "draft" : "published";
        const resultsPerPage = 10;
        setTag("request.method", "GET");
        setTag("request.params", params);
        if (hasMakeParam(params)) {
            setTag("request.params.make", params.make);
            make = params === null || params === void 0 ? void 0 : params.make;
            console.log("Make is set to", make);
        }
        if (make === "undefined") {
            setTag("request.params.make", "undefined");
            return {
                redirect: {
                    destination: `/reviews/`,
                    permanent: true
                }
            };
        }
        if (hasModelParam(params)) {
            setTag("request.params.model", params.model);
            model = params === null || params === void 0 ? void 0 : params.model;
        }
        if (model === "undefined") {
            setTag("request.params.model", "undefined");
            return {
                redirect: {
                    destination: `/reviews/${make}`,
                    permanent: true
                }
            };
        }
        if (hasPageParam(params)) {
            setTag("request.params.page", params.page);
            page = Number(params === null || params === void 0 ? void 0 : params.page);
            let destination = "/reviews";
            if (make && model) {
                destination = `${destination}/${make}/${model}`;
            }
            if (make && !model) {
                destination = `${destination}/${make}`;
            }
            if (page === 1) {
                return {
                    redirect: {
                        destination,
                        permanent: true
                    }
                };
            }
        }
        const [story, { reviews , total: numberOfReviews  }, makeOptions, modelOptions] = await Promise.all([
            getStory({
                version
            }),
            getReviews({
                page,
                perPage: 10,
                version,
                make,
                model
            }),
            getMakeOptions(version),
            getModelOptions(make, version)
        ]);
        return {
            props: {
                isISR: true,
                preview,
                story,
                currentPage: page,
                numberOfReviews,
                selectedMake: make ?? null,
                selectedModel: model ?? null,
                makeOptions,
                modelOptions,
                resultsPerPage,
                reviews,
                layoutProps: {
                    showBorderRadius: true
                },
                generatedAt: Date.now()
            },
            revalidate: 60
        };
    } catch (error) {
        console.log(error);
        if (error instanceof Error || typeof error === "string") {
            setTag("response.statusCode", 404);
            tagError(error);
        }
        return {
            notFound: true,
            revalidate: 10
        };
    }
}
function hasPageParam(params) {
    return typeof (params === null || params === void 0 ? void 0 : params.page) === "string";
}
function hasMakeParam(params) {
    return typeof (params === null || params === void 0 ? void 0 : params.make) === "string";
}
function hasModelParam(params) {
    return typeof (params === null || params === void 0 ? void 0 : params.model) === "string";
}
async function getStory({ version  }) {
    const storyArgs = {
        version
    };
    if (version === "draft") {
        storyArgs.cv = Date.now();
    }
    const story = await getStoryBySlug("car-review-hub", storyArgs);
    if (!story || !story.content || story.content.component !== "ReviewHubPage") {
        throw new Error(`Failed to load story for 'car-review-hub' received: "${JSON.stringify(story, null, 4)}"`);
    }
    return story;
}
async function getModelOptions(make, version) {
    try {
        if (!make) {
            return [];
        }
        const storyArgs = {
            version,
            page: 1,
            starts_with: `car-reviews-v2/${dashify(make)}`,
            per_page: 100
        };
        if (version === "draft") {
            storyArgs.cv = Date.now();
        }
        const { stories  } = await getStories(storyArgs);
        if (!stories) return [];
        const tags = stories.map((story)=>story.content.model).sort();
        if (!tags) return [];
        return [
            ...new Set(tags)
        ];
    } catch (error) {
        console.error(`Error in getModelOptions: ${error}`);
        return [];
    }
}
async function getMakeOptions(version) {
    const args = {
        starts_with: "car-reviews-v2/",
        version,
        sort_by: "content.make:asc"
    };
    if (version === "draft") {
        args.cv = Date.now();
    }
    const makes = (await getAllStories(args)).stories.map((story)=>story.content.make);
    return [
        ...new Set(makes)
    ];
}
async function getReviews({ page =1 , perPage =10 , version ="published" , make , model  } = {}) {
    try {
        let starts_with = "car-reviews-v2/";
        if (make) {
            starts_with = `car-reviews-v2/${dashify(make)}`;
        }
        if (make && model) {
            starts_with = `car-reviews-v2/${dashify(make)}/${dashify(model)}`;
        }
        const reviewListArgs = {
            version,
            starts_with,
            page,
            per_page: perPage,
            sort_by: "published_at:desc"
        };
        if (version === "draft") {
            reviewListArgs.cv = Date.now();
        }
        const reviewListData = await getStories(reviewListArgs);
        const reviews = reviewListData.stories.map((story)=>toReview(story));
        return {
            reviews,
            total: reviewListData.total
        };
    } catch (error) {
        console.error(`Error in getReviews: ${error}`);
        return {
            reviews: [],
            total: 0
        };
    }
}
const formattedHref = (url)=>url.replace(/car-reviews-v2/g, "/used-cars");
function toReview(input) {
    var ref, ref1, ref2;
    return {
        path: formattedHref(input.full_slug),
        title: input.content.title,
        heroImage: ((ref = input.content) === null || ref === void 0 ? void 0 : (ref1 = ref.gallery) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.image) ?? null,
        date: input.published_at ?? "",
        make: input.content.make,
        model: input.content.model,
        starRating: input.content.starRating,
        id: input.uuid,
        snippet: input.content.snippet ?? ""
    };
}

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-hub/src/lib/get-static-paths.ts


function getStaticPathsForPage() {
    return async ()=>({
            paths: [
                {
                    params: {
                        page: "2"
                    }
                }
            ],
            fallback: "blocking"
        });
}
const getLinks = (0,datadog_server_src/* traceFunction */.KG)("getLinks", src/* getLinks */.rx);
function getStaticPathForMakes({ requiresPage =false  }) {
    return async ()=>{
        const makes = (await getTopMakes()).slice(0, 10);
        const paths = makes.map(({ make  })=>({
                params: {
                    make,
                    page: requiresPage ? "2" : undefined
                }
            }));
        return {
            paths,
            fallback: "blocking"
        };
    };
}
function getStaticPathForModels({ requiresPage =false  }) {
    return async ()=>{
        const makes = (await getTopMakes()).slice(0, 10);
        const models = (await Promise.all(makes.map(({ make  })=>getTopModelForMake(make)))).flat();
        const paths = models.map(({ make , model  })=>({
                params: {
                    make,
                    model,
                    page: requiresPage ? "2" : undefined
                }
            }));
        return {
            paths,
            fallback: "blocking"
        };
    };
}
async function getTopMakes() {
    const links = await getLinks("car-reviews-v2/");
    const makes = Object.values(links).reduce((acc, link)=>{
        if (link.is_folder && link.slug !== "car-reviews-v2") {
            acc.push(link.slug.replace("car-reviews-v2/", ""));
        }
        return acc;
    }, []);
    return [
        ...new Set(makes)
    ].flatMap((make)=>({
            make
        }));
}
async function getTopModelForMake(make) {
    const links = await getLinks(`car-reviews-v2/${make.toLocaleLowerCase()}`);
    const models = Object.values(links).filter((link)=>link.slug !== "car-reviews-v2").filter((link)=>link.is_folder).filter((link)=>link.slug.startsWith(`car-reviews-v2/${make}`)).map((link)=>link.slug.replace(`car-reviews-v2/${make}`, "")).map((slug)=>slug.replace("/", "").trim()).filter((link)=>link !== "");
    return [
        ...new Set(models)
    ].flatMap((model)=>({
            make,
            model
        }));
}

;// CONCATENATED MODULE: ../../../libs/landing/feature-car-reviews-hub/src/index.ts





/***/ }),

/***/ 23754:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page":"car-reviews-hub_page__9xnnA"};

/***/ }),

/***/ 53584:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"filters_container__VbotL","selectContainer":"filters_selectContainer__KWlw0","select":"filters_select___1VdI"};

/***/ }),

/***/ 89671:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"reviewsHeader":"header_reviewsHeader___2n5c","subtitle":"header_subtitle__3rwLR"};

/***/ }),

/***/ 40983:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"no-reviews_container__udPq8","header":"no-reviews_header__Mo6Ur","body":"no-reviews_body__NiM42","icon":"no-reviews_icon__2qkC8"};

/***/ }),

/***/ 269:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"review-card_root__9cGpj","title":"review-card_title__zKYpm","imageContainer":"review-card_imageContainer__bp4LL","featured":"review-card_featured__IFevK","topCard":"review-card_topCard__xNn8v","image":"review-card_image__JNv1Z","snippet":"review-card_snippet__TmJD3"};

/***/ }),

/***/ 90710:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"review-cards-list_link__91i7e","listItem":"review-cards-list_listItem__LpMkK","noResults":"review-cards-list_noResults__bQ4LW"};

/***/ }),

/***/ 41365:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"starRatingContainer":"star-rating_starRatingContainer__vBFHd"};

/***/ })

}]);